module.exports = __webpack_public_path__ + "img/bg.e74a6233.png";